// Remembers on this device whether the signed-in account has a paid plan, for
// the <head> ad marker (headMarker.js), which runs before the plan is known.
const KEY = 'olm_paid'

export function setStoredPaid(paid: boolean): void {
  try {
    if (paid) localStorage.setItem(KEY, '1')
    else localStorage.removeItem(KEY)
  } catch { /* storage blocked: the marker falls back to the session's tier */ }
}
